import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent {
    @Input() id: string;
    @Input() label: string;
    @Input() visible: boolean = true;
    @Input() hidden: boolean = false;
    @Input() disabled: boolean = false;
    @Input() selected: boolean = false;
    @Input() href: string | null = null;
    @Input() target: string | null = null;
    @Input() showLaunchIcon: boolean = false;

    @Output() itemClick = new EventEmitter<void>();
    @Output() externalClick = new EventEmitter<MouseEvent>();
}
